module.exports = function(container) {

    container.find('.is-invalid').removeClass('is-invalid');

    container.find('.invalid-feedback').remove();

}